import $ from 'jquery';

const Header = {
  init() {
    this.headerChange();
    this.setupScrollEvent();
  },
  
  headerChange() {
    const mv = $('.js-fv_h').outerHeight();
    const scroll = $(window).scrollTop();
    
    if (scroll > mv) {
      $('.js-toggle').fadeIn();
    } else {
      $('.js-toggle').fadeOut();
    }
  },
  
  setupScrollEvent() {
    $(window).on('scroll', () => {
      this.headerChange();
    });
  }
}

// 初期化
Header.init();

export default Header;